<template>
  <b-col
    xl="5"
    md="12"
    sm="12"
  >
    <b-card
      no-body
      class="card-statistics"
    >
      <div class="bg-light-primary rounded-top" />
      <b-card-header class="align-items-baseline border-bottom bg-success rounded-top">
        <div>
          <b-card-title
            class="font-medium-5 text-light"
          >
            {{ $t('Engagement') }}
          </b-card-title>
        </div>
      </b-card-header>
      <b-card-body class="statistics-body">
        <b-row>
          <b-col
            md="4"
            sm="6"
            class="mb-2 mb-sm-0"
          >
            <b-media no-body>
              <b-media-aside

                class="mr-2 text-center"
              >
                <b-avatar
                  size="48"
                  variant="light-primary"
                >
                  <feather-icon
                    size="24"
                    icon="VideoIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <b-card-text class="font-small-3 font-weight-bold mb-0">
                  {{ $t('Launched Ratio') }}
                </b-card-text>
                <h4 class="font-weight-bolder mb-0">
                  {{ engagementData.videoLaunchRatio || "n/a" }}%
                </h4>
              </b-media-body>
            </b-media>
          </b-col>
          <b-col
            md="4"
            sm="6"
            class="mb-2 mb-md-0"
          >
            <b-media no-body>
              <b-media-aside

                class="mr-2"
              >
                <b-avatar
                  size="48"
                  variant="light-info"
                >
                  <feather-icon
                    size="24"
                    icon="WatchIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <b-card-text class="font-small-3 font-weight-bold mb-0">
                  {{ $t('Avg. Play Time') }}
                </b-card-text>
                <h4 class="font-weight-bolder mb-0">
                  {{ engagementData.videoPlayedTimeAvg || "n/a" }}
                </h4>
                <h6
                  v-if="engagementData.videoPlayedTimeTotal"
                  class="font-small-2 mb-0"
                >
                  Total Play Time: {{ engagementData.videoPlayedTimeTotal }}
                </h6>
              </b-media-body>
            </b-media>
          </b-col>
          <b-col
            md="4"
            sm="6"
            class="mb-2 mb-md-0"
          >
            <b-media no-body>
              <b-media-aside

                class="mr-2"
              >
                <b-avatar
                  size="48"
                  variant="light-success"
                >
                  <feather-icon
                    size="24"
                    icon="CheckIcon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <b-card-text class="font-small-3 font-weight-bold mb-0">
                  {{ $t('Completed Ratio') }}
                </b-card-text>
                <h4 class="font-weight-bolder mb-0">
                  {{ engagementData.videoCompletedRation }}%
                </h4>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>

import {
    BRow, BCol, BCard, BCardTitle, BCardHeader, BCardText, BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardHeader,
        BCardText,
        BCardBody,
        BMedia,
        BMediaAside,
        BAvatar,
        BMediaBody,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        engagementData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
}
</script>
